import validator from 'validator';

const E_PASSWORD_EMPTY = 'Please enter a new password';
const E_PASSWORD_CONFIRM_EMPTY = 'Please confirm your new password';
const E_PASSWORD_MATCH = 'Your password and password confirmation must match';
const E_PASSWORD_LENGTH = 'Your password must be at least 8 characters long';
const E_PASSWORD_CONFIRM_LENGTH =
  'Your password confirmation must be at least 8 characters long';

const isEmpty = (value) => validator.isEmpty(value, { ignore_whitespace: true });

export const validate = ({ password, passwordConfirm }) => {
  var errors = {};

  if (isEmpty(password || '')) {
    errors.password = E_PASSWORD_EMPTY;
  }

  if (isEmpty(passwordConfirm || '')) {
    errors.passwordConfirm = E_PASSWORD_CONFIRM_EMPTY;
  }

  if (!errors.password && password.length < 8) {
    errors.password = E_PASSWORD_LENGTH;
  }

  if (!errors.passwordConfirm && passwordConfirm.length < 8) {
    errors.passwordConfirm = E_PASSWORD_CONFIRM_LENGTH;
  }

  if (!errors.password && !errors.passwordConfirm && password !== passwordConfirm) {
    errors.password = E_PASSWORD_MATCH;
    errors.passwordConfirm = E_PASSWORD_MATCH;
  }

  return [!Object.getOwnPropertyNames(errors).length, errors];
};

export default validate;
